import { Component, EventEmitter, OnInit, Output, AfterContentInit, OnChanges, SimpleChanges, Input  } from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, AfterContentInit, OnChanges  {

  filterForm: FormGroup;
  @Output() filterChange = new EventEmitter();
  @Input() instanceId?:number;
  @Input() plotFilter: any;

  constructor( private fb:FormBuilder) { 
    this.filterForm = this.filterForm = this.fb.group({});
 
  }
  ngOnChanges(changes: SimpleChanges): void {
    let { instanceId  } = changes;
    if(changes['plotFilter']) {
      this.initFilterForm();
    }
    // let {currentValue, previousValue} = instanceId;
    // if(currentValue != previousValue){
    //   this.reset();
    // }
  }
  ngAfterContentInit(){
  }
  ngOnDestroy(){
  }


  initFilterForm(){
    if (this.plotFilter) {
      // console.log('yes received');
      // console.log(this.plotFilter.mf2)
      this.filterForm = this.fb.group({
        htl: new FormGroup({
          left: new FormControl(this.plotFilter.htl.left),
          right: new FormControl(this.plotFilter.htl.right)
        }),
        mf2: new FormGroup({
          left: new FormControl(this.plotFilter.mf2.left),
          right: new FormControl(this.plotFilter.mf2.right),
          aahl_l: new FormControl(this.plotFilter.mf2.aahl_l),
          aahl_pts_l: new FormControl(this.plotFilter.mf2.aahl_pts_l),
          aahl_r: new FormControl(this.plotFilter.mf2.aahl_r),
          aahl_pts_r: new FormControl(this.plotFilter.mf2.aahl_pts_r)
        }),
        lcb: new FormGroup({
          left: new FormControl(false),
          right: new FormControl(false)
        })
      });
    } else {
      // console.log('not yet received');
      this.filterForm = this.fb.group({
        htl: new FormGroup({
          left: new FormControl(true),
          right: new FormControl(true)
        }),
        mf2: new FormGroup({
          left: new FormControl(false),
          right: new FormControl(false),
          aahl_l: new FormControl(false),
          aahl_pts_l: new FormControl(false),
          aahl_r: new FormControl(false),
          aahl_pts_r: new FormControl(false)
        }),
        lcb: new FormGroup({
          left: new FormControl(false),
          right: new FormControl(false)
        })
      });
    }
    this.filterForm.valueChanges.subscribe(val => {
      // console.log(val)
        this.filterChange.emit(val);
    })
  }

  ngOnInit(): void {
    this.initFilterForm();
    // console.log('test this.plotfilter');
    // console.log(this.plotFilter)
    // console.log(this.plotFilter.htl.left)
  }
  export():void {
    this.filterChange.emit(this.filterForm.getRawValue());
  }
  checkMF2Modification() {
    // let mf2 = this.filterForm.value.mf2;
    // if(mf2.left || mf2.right){
    //   if(!mf2.aahl && !mf2.aahl_pts){
    //     this.filterForm.controls["mf2"].setValue({
    //       ...this.filterForm.controls["mf2"].value,
    //       aahl : true,
    //     });
    //   }
    // } 
    // if(!mf2.left &&  !mf2.right){
    //   this.filterForm.controls["mf2"].setValue({
    //     ...this.filterForm.controls["mf2"].value,
    //     aahl : false,
    //     aahl_pts: false
    //   });
    // }
    let mf2 = this.filterForm.value.mf2;
    // console.log(mf2)
    if(mf2.left) {
      if(!mf2.aahl_l && !mf2.aahl_pts_l) {
        this.filterForm.controls["mf2"].setValue({
          ...this.filterForm.controls["mf2"].value,
          aahl_l : true,
        });
      }
    }
    if(mf2.right) {
      if(!mf2.aahl_r && !mf2.aahl_pts_r) {
        this.filterForm.controls["mf2"].setValue({
          ...this.filterForm.controls["mf2"].value,
          aahl_r : true,
        });
      }
    }
    if(!mf2.left) {
      this.filterForm.controls["mf2"].setValue({
        ...this.filterForm.controls["mf2"].value,
        aahl_l : false,
        aahl_pts_l : false
      });
    }
    if(!mf2.right) {
      this.filterForm.controls["mf2"].setValue({
        ...this.filterForm.controls["mf2"].value,
        aahl_r : false,
        aahl_pts_r : false
      });
    }

  }

  reset():void {
    this.initFilterForm();
    this.export();
  }
}
